import { useCallback } from "react";
import { useMount } from "react-use";

export const useInfiniteScroll = ({
    hasMoreData,
    totalItemsCount,
    isDataLoading,
    loadMore,
    listRef,
    currentScrollPosition,
    setCurrentScrollPosition,
}) => {
    // Restore scroll position on mount if needed
    useMount(() => {
        if (listRef.current && currentScrollPosition > 0) {
            requestAnimationFrame(() => {
                listRef.current?.scrollTo(currentScrollPosition);
            });
        }
    });

    const isItemLoaded = useCallback(
        (index) => {
            return !hasMoreData || index < totalItemsCount;
        },
        [hasMoreData, totalItemsCount]
    );
    const displayItemCount = hasMoreData ? totalItemsCount + 1 : totalItemsCount;

    const loadMoreItems = useCallback(
        async (startIndex, stopIndex) => {
            if (isDataLoading || !hasMoreData) {
                return;
            }
            if (loadMore && listRef.current) {
                const currentOffset = listRef.current.state.scrollOffset;
                setCurrentScrollPosition(currentOffset);

                await loadMore();
            }
        },
        [hasMoreData, isDataLoading, listRef, loadMore, setCurrentScrollPosition]
    );

    return {
        isItemLoaded,
        displayItemCount,
        loadMoreItems,
    };
};
